import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import ApiService2 from '../../../POS/services/apiService';
import userManagement from '../../../POS/services/userManagement';
import { useLocation, useNavigate } from 'react-router-dom';
import ItemlistGrid from './itemsGrid';
import IssueAuthorization from './issueAuthorization';
import IssueMessageGrid from './IssueMessage';
import { useSelector } from 'react-redux';
import { getName } from '../../../Redux/selecters';
import { FaAngleLeft } from "react-icons/fa6";
import ItemlistGridView from './viewGrid';
import Modal from 'react-bootstrap/Modal';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const IssueView = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [SelectedIssue, setSelectedIssue] = useState();
    const [itemNo, setItemNo] = useState();
    const userName = useSelector(getName);
    const location = useLocation();
    const [POTab, setPOTab] = useState(true);
    const { currencyPrecision } = useCurrency();
    const itemData = location.state;
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);
    const handleClose = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const todayDate = new Date().toISOString().substr(0, 10);
    const [formData, setFormData] = useState({
        requisitionNo: "",
        itemType: "",
        quatotionNo: "",
        remarks: "",
        requestor: "",
        date: todayDate,
        requisitionDate: todayDate,
        deliveryDate: todayDate,
        currencyCode: "",
        exchangeRate: "",
        department: [],
        costCenter1: [],
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        description: "",
        fromLocation: [],
        toLocation: [],
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        subcatname: "",
        refNo: "",
        StockType: ""
    })
    useEffect(() => {
        getLocation()
    }, [])
    useEffect(() => {
        const item = location.state;
        if (item.docno) {
            const fetchData = async (item) => {
                const apiService = new ApiService();
                const res = await apiService.get('GET_ITEM_ISSUE');
                const selectedIssue = res.data.result?.find(itm => itm?.issueNo === item.docno)
                setSelectedIssue(selectedIssue)
                setFormData({
                    recordId: selectedIssue?.recordId,
                    requisitionDate: selectedIssue?.requisitionDate || todayDate,
                    date: selectedIssue.issueDate,
                    deliveryDate: selectedIssue?.deliveryDate ? selectedIssue.deliveryDate.substr(0, 10) : todayDate,
                    requisitionNo: selectedIssue?.requisitionNo,
                    description: selectedIssue?.description,
                    refNo: selectedIssue?.issueRefNo,
                    remarks: selectedIssue?.remarks,
                    requestor: selectedIssue?.requestor,
                    currencyCode: selectedIssue?.currencyCode,
                    costCenter2: selectedIssue?.costCenter2,
                    costCenter3: selectedIssue?.costCenter3,
                    costCenter4: selectedIssue?.costCenter4,
                    deliveryPoint: selectedIssue?.deliveryPoint,
                    contactPerson: selectedIssue?.contactPerson,
                    contatNo: selectedIssue?.contatNo,
                    taskCode: selectedIssue?.projectCode,
                    location: selectedIssue?.location,
                    department: selectedIssue.department,
                    fromLocation: { label: selectedIssue?.warehouse, value: selectedIssue?.warehouse },
                    toLocation: { label: selectedIssue?.divisionCode, value: selectedIssue?.divisionCode }
                });
            }
            fetchData(item)
        } else {
            setFormData({
                recordId: item?.recordId,
                requisitionDate: item?.requisitionDate || todayDate,
                date: item.issueDate,
                deliveryDate: item?.deliveryDate ? item.deliveryDate.substr(0, 10) : todayDate,
                requisitionNo: item?.requisitionNo,
                description: item?.description,
                refNo: item?.issueRefNo,
                remarks: item?.remarks,
                requestor: item?.requestor,
                currencyCode: item?.currencyCode,
                exchangeRate: item?.exchangeRate,
                costCenter2: item?.costCenter2,
                costCenter3: item?.costCenter3,
                costCenter4: item?.costCenter4,
                deliveryPoint: item?.deliveryPoint,
                contactPerson: item?.contactPerson,
                contatNo: item?.contatNo,
                taskCode: item?.projectCode,
                location: item?.location,
                department: item.department,
                fromLocation: { label: item?.warehouse, value: item?.warehouse },
                toLocation: { label: item?.divisionCode, value: item?.divisionCode }
            });
        }
        setItemNo(item.issueNo || item.docno)
    }, [location?.state]);

    const getLocation = async () => {
        try {
            if (currencyPrecision) {
                setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleMessage = (data) => {
        console.log(data, 'reqData')
    }
    const handleRequisitionData = (data) => {
        console.log(data, 'reqData')
    }
    const handleAuthorization = (data) => {
        console.log(data, 'reqData')
    }
    const handleBackClick = () => {
        window.history.back();
    }

    const handleFileSelect = (event, id) => {
        const file = event.target.files[0];
        if (file) {
            setAttachmentList((prevList) => [
                ...prevList.map((attachment) =>
                    attachment.id === id ? { ...attachment, fileName: file.name, file: file } : attachment
                ),
                { id: Date.now(), fileName: '', remarks: '' },
            ]);
        }
    };
    const handleView = (file) => {
        if (file && file instanceof File) {
            setPreviewImage(URL.createObjectURL(file));
            setPreviewModal(true);
        } else {
            console.error("No valid file to preview");
        }
    };
    const handleDelete = (id) => {
        const updatedList = attachmentList.filter((attachment) => attachment.id !== id);
        setAttachmentList(updatedList);
    };
    return (
        <div className='px-4 pb-5'>
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Issue Items</h5>
                <div className='d-flex gap-3'>
                    <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Issue Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="itemNo" className="form-label  pt-2 start">Issue Note No</label>
                                <input className="form-Input w-70" disabled value={itemNo} name="itemNo" />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label className="form-label  pt-2 start">Currency</label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled value={SelectedCurrency} />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label className="form-label  pt-2 start">Exchange Rate</label>
                                <input disabled value={formData.exchangeRate} className="form-Input w-70" />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Requisition No</label>
                                <input disabled className="form-Input w-70" value={formData.requisitionNo} />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor={formData.department} className="form-label  pt-2 start">Department</label>
                                <input disabled className="form-Input w-70" value={formData.department} />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Property</label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Date </label>
                                <input className='form-Input w-70' type='date' disabled defaultValue={new Date().toISOString().substr(0, 10)} />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="description" className="form-label  pt-2 start">Description</label>
                                <input disabled value={formData.description} className="form-Input w-70" />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="costCenter1" className="form-label  pt-2 start">Unit</label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled value={formData.costCenter1} />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">From Location </label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled value={formData.fromLocation} />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="contactPerson" className="form-label  pt-2 start">Requester</label>
                                <input disabled value={formData.contactPerson} className="form-Input w-70" />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 3</label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled value={formData.department} />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">To Location</label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled value={formData.toLocation} />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Issued By</label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled value={{ label: userName, value: userName }} />
                            </div>
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 4</label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between ">
                                <label htmlFor="refNo" className="form-label  pt-2 start">Ref No</label>
                                <input disabled className="form-Input w-70" value={formData.refNo} />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Request Date </label>
                                <input className='form-Input w-70' value={formData.requisitionDate} type='date' disabled defaultValue={new Date().toISOString().substr(0, 10)} />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Delivery Date </label>
                                <input className='form-Input w-70' type='date' disabled defaultValue={new Date().toISOString().substr(0, 10)} />
                            </div>
                        </div>
                        <div className="form-group row ">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Stock Type</label>
                                <Select
                                    className="w-70 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }} isDisabled value={formData.StockType} />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="remarks" className="form-label  pt-2 start">Remarks</label>
                                <input disabled className="form-Input w-70" value={formData.remarks} />
                            </div>
                            <div className='col-1 px-5 mx-3'></div>
                            {/* <div className="col-2 brderbox center p-2" onClick={() => handleOpen()} >
                                {'Attachment'}
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
                            Requisition
                        </div>
                        <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
                            Authorization
                        </div>
                        <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
                            Message
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid-1 brderbox2 p-4 mb-3">
                {gridVisibility[0] && (
                    <ItemlistGridView onRequisitionData={handleRequisitionData} itemData={itemData} formData={formData}
                        SelectedIssue={SelectedIssue} currencyPrecision={currencyPrecision?.precision || 3} />
                )}
                {gridVisibility[1] && (
                    <IssueAuthorization handleAuthorization={handleAuthorization} itemData={itemData} />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border"><IssueMessageGrid handleMessage={handleMessage} /></div>
                )}
            </div>

            <div>
                <Modal show={attachmentModal} size="lg" onHide={handleClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Attachments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col d-flex justify-content-between">
                            <label htmlFor="docNp" className="form-label  pt-2 start">Document No</label>
                            <input disabled value={itemNo} className="form-Input w-70" />
                        </div>
                        <div className="pt-2">
                            <table>
                                <thead className="dynoTable">
                                    <tr>
                                        <th>File Name</th>
                                        <th>Remarks</th>
                                        <th>Upload</th>
                                        <th>View</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachmentList?.map((attachment, index) => (
                                        <tr key={attachment.id}>
                                            <td className='m-0 p-0'><input className='p-0' type='text' disabled value={attachment.fileName} style={{ width: "320px" }} /></td>
                                            <td>
                                                <input type="text" value={attachment.remarks}
                                                    onChange={(e) => {
                                                        const updatedList = attachmentList?.map((item) =>
                                                            item.id === attachment.id ? { ...item, remarks: e.target.value } : item
                                                        );
                                                        setAttachmentList(updatedList);
                                                    }}
                                                    style={{ width: '345px' }}
                                                />
                                            </td>
                                            <td>
                                                <button className='mainbtn ' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                                <input
                                                    type="file" accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleFileSelect(e, attachment.id)}
                                                    id={`fileInput-${attachment.id}`}
                                                />
                                            </td>
                                            <td><button className='mainbtnRed ' onClick={() => handleView(attachment.file)} disabled={!attachment.fileName}>
                                                <div>View</div></button></td>
                                            <td>
                                                <button onClick={() => handleDelete(attachment.id)} disabled={!attachment.fileName} className='mainbtnSecondary'>
                                                    <div>Delete</div></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='mainbtn' onClick={handleClose} >Attach</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    )
}

export default IssueView